import AU from "assets/images/app-download-qr-codes/AU.svg";
import CA from "assets/images/app-download-qr-codes/CA.svg";
import GB from "assets/images/app-download-qr-codes/GB.svg";
import NZ from "assets/images/app-download-qr-codes/NZ.svg";
import US from "assets/images/app-download-qr-codes/US.svg";

import { Locale } from "@/types/locale";

export type Props = {
    locale: Locale;
};

const regionToQRCode = {
    "en-US": US,
    "en-CA": CA,
    "fr-CA": CA,
    "en-AU": AU,
    "en-NZ": NZ,
    "en-GB": GB,
};

export const AppDownloadQRCode = ({ locale }: Props) => {
    const QrCodeComponent = regionToQRCode[locale];

    if (!QrCodeComponent) {
        return null;
    }

    return <QrCodeComponent />;
};
